import React from "react";
import useAuth from "../hooks/useAuth";
import { Navigate } from "react-router-dom";
import useUser from "../hooks/useUser";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { isSubscribed, loadingUser } = useUser();

  return isAuthenticated() ? (
    isSubscribed() ? (
      <Navigate to="/dashboard" />
    ) : (
      children
    )
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
